import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import Styles from './Actions.module.scss'
import { Button } from 'components/Button/Button'

const Actions = observer(() => {
  const docStore = useDocStore()
  const { acceptAll, changesCount } = docStore.trackedChangesStore
  const isDisabled =
    docStore.cleanupModeStore.todosForCleanup.length + docStore.cleanupModeStore.commentsForCleanup.length < 1

  return (
    <div className={Styles.actions}>
      <Button variant="secondary" size="md" onPress={acceptAll} isDisabled={!changesCount}>
        Accept All
      </Button>
      <Button
        variant="secondary"
        size="md"
        onPress={docStore.cleanupModeStore.resolveAllCommentsAndTodos}
        isDisabled={isDisabled}
      >
        Resolve All
      </Button>
    </div>
  )
})

export { Actions }
